import React from 'react'
import './Image.css'
function Image() {
    return (
        <div className="border">
        <img class="ui medium bordered image" className="image" src={require('./image/download2.jpg').default } alt=""></img>
        </div>
    
   
    )
}

export default Image
